export enum RecipeType {
	Hot = 'hot',
	Cold = 'cold',
	Frozen = 'frozen',
	Drink = 'drink',
	Cutlery = 'cutlery',
	Snack = 'snack',
	NonFood = 'non-food',
}

/**
 * Human-readable recipe/product category labels (backend stores slug values).
 * Kept in sync with Platform product Category column and filters.
 */
export const RECIPE_CATEGORY_DISPLAY_LABELS = {
	[RecipeType.Hot]: 'Hot',
	[RecipeType.Cold]: 'Fresh',
	[RecipeType.Frozen]: 'Frozen',
	[RecipeType.Drink]: 'Drinks',
	[RecipeType.Cutlery]: 'Cutlery',
	[RecipeType.Snack]: 'Snacks',
	[RecipeType.NonFood]: 'Non-food',
} as const

const SUBTITLE_SEP = ' • '

/** Subtitle for omnibar/search results: "Product • Category • Size" */
export function formatProductSearchSubtitle(product: {
	type?: string | null
	size_value?: number | null
	size_unit?: string | null
}): string {
	const parts = ['Product']
	const category = product.type
		? RECIPE_CATEGORY_DISPLAY_LABELS[product.type as keyof typeof RECIPE_CATEGORY_DISPLAY_LABELS]
		: ''
	if (category) parts.push(category)
	if (product.size_value != null && product.size_unit) {
		parts.push(`${product.size_value} ${product.size_unit}`)
	}
	return parts.join(SUBTITLE_SEP)
}
